import { steps } from '@/mocks/home';

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-background-50 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-24">
        <p className="text-xs font-bold tracking-[0.2em] text-accent-600 mb-2">SIMPLE PROCESS</p>
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-10 md:mb-14">How it works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <article key={s.num} className="rounded-3xl bg-background-50 border border-background-200 p-6 md:p-8 shadow-pink">
              <div className="flex items-center justify-between mb-6">
                <span className={`font-heading font-bold text-5xl md:text-6xl ${i === 1 ? 'text-accent-500' : 'text-primary-600'}`}>{s.num}</span>
                <span className="w-11 h-11 rounded-full bg-primary-50 text-primary-600 text-xl flex items-center justify-center"><i className={s.icon}></i></span>
              </div>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950 mb-2">{s.title}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}